import {ErrorStateScheduleEnum} from '../error-state-schedule.enum';

export enum PanelSettingsOperatorsResolverErrorStatesEnum {
    GetRolesFailed = ErrorStateScheduleEnum.PanelSettingsOperatorsResolverErrorStatesStartIndex,
    GetOperatorsFailed
}
